import { apiClient } from "@/lib/api-client";

export interface MasterPeriodeKelasProdi {
  kode_unit: string;
  nama_prodi: string;
  kode_fakultas: string;
  jumlah_mhs: number;
  kelas: number;
  program: string;
}

export interface MasterPeriodeKelasFakultas {
  kode_fakultas: string;
  nama_fakultas: string;
  total_mhs_fakultas: number;
  kelas_fakultas: number;
  prodi: MasterPeriodeKelasProdi[];
}

export interface MasterPeriodeKelasResponse {
  datas: MasterPeriodeKelasFakultas[];
}

export const fetchMasterPeriodeKelas = async (periodeId: string | number) => {
  if (!periodeId) return null;
  const res = await apiClient<MasterPeriodeKelasResponse>(
    `/api/v1/master-periode-kelas?periodeId=${periodeId}`,
  );
  return res;
};
